module.exports = __webpack_public_path__ + "img/dangdang.9a7d6b3e.png";